import { notification, Button } from 'antd';
import { history } from '@umijs/max';
import React from 'react';

export const validateCredits = (creditsRemaining: number, type: string): boolean => {
  if (creditsRemaining <= 0) {
    notification.error({
      message: `You have no ${type} credits remaining. Please upgrade your plan.`,
      description: 'You can upgrade your plan by clicking the button below.',
      placement: 'bottomRight',
      btn: React.createElement(
        Button,
        {
          style: { backgroundColor: 'black', color: 'white', borderColor: 'black' },
          onClick: () => history.push('/pricing')
        },
        'View Plans'
      )
    });
    return false;
  }
  return true;
};


